import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { getPermissionDescription } from '../../utils/permissionTranslations';
import { BRAND } from '../../theme/brandTokens';

const PermissionInfoIcon = ({ permissionTranslations, language }) => {
  const { t } = useTranslation();
  const description = getPermissionDescription(permissionTranslations, language);

  if (!description) {
    return null;
  }

  return (
    <Tooltip
      title={description}
      arrow
      placement="top"
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: { offset: [0, -20] },
            },
          ],
        },
      }}
    >
      <IconButton
        component="span"
        size="small"
        aria-label={t('permissions.infoAriaLabel')}
        onMouseDown={(event) => event.preventDefault()}
        onClick={(event) => event.stopPropagation()}
        sx={{
          p: 0.25,
          color: '#8a8a8a',
          '&:hover': {
            color: BRAND.accentText,
            backgroundColor: 'transparent',
          },
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  );
};

export default PermissionInfoIcon;
